import {Serializers} from "../../interfaces/serializer";
import {DimensionComponentObjects} from '../../classes/dimension-component-object';

import {DataSourceDimension} from '../../interfaces/dimensions';

export const DATA_SOURCE_DIMENSIONS_STATE_NAME = 'dataSourceDimensions';

export interface DataSourceDimensionsState {
  serialized: Serializers<DataSourceDimension>;
  componentObjects: DimensionComponentObjects;
  loading: boolean;
  loaded: boolean;
}
